export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/selected-star-icon.png?8bf913ccef025d6fcaeb1f735c592616";